define([
	'canvas/LogoCanvas',
	'lib/jquery'
], function (
	LogoCanvas,
	jQuery
) {
	'use strict';

	/**
	 * SplashScreenView class
	 */
	return function () {
		var _logoCanvas = new LogoCanvas(),
			_view;

		_view = (function () {
			var $view = jQuery('<div id="skIdS_splash-screen">' +
									'<div></div>' +
									'<div>&nbsp;</div>' +
								'</div>');

			$view.children().first().append(_logoCanvas.get());

			return $view;
		})();


		// public methods

		this.get = function () {
			return _view;
		};

		this.setStatusText = function (text) {
			_view.children().last()
				.empty()
				.append(text);
		};

		this.enableAnimation = function () {
			_logoCanvas.enableAnimation();
		};

		this.disableAnimation = function () {
			_logoCanvas.disableAnimation();
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/SplashScreenView.js
// module id = 95
// module chunks = 1